var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
// TEAM_TICKET_FLAGS
var TEAM_TICKET_FLAGS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query TeamTicketFlags($id: ID!) {\n    team(id: $id) {\n      id\n      ticket_flags {\n        id\n        active\n        display_name\n      }\n    }\n  }\n"], ["\n  query TeamTicketFlags($id: ID!) {\n    team(id: $id) {\n      id\n      ticket_flags {\n        id\n        active\n        display_name\n      }\n    }\n  }\n"])));
export var useTeamTicketFlagsQuery = function (options) {
    return useQuery(TEAM_TICKET_FLAGS, options);
};
export default TEAM_TICKET_FLAGS;
var templateObject_1;
